export default __webpack_public_path__ + "static/media/DeltaTech.11b1bb22.svg";